﻿import React from 'react';

//lib
import { v4 as uuidv4 } from 'uuid';

// utils
import RawHtml from '../../../UI/RawHtml';
import IconHelper from '@bazooka_se/lf-icons';

//components 
import PossessionsTableBase from './Table/PossessionsTableBase';


const PossessionsTabs = (props) => {

    const [mobile, setMobile] = React.useState(false);

    React.useEffect(() => {
        if (window.innerWidth < 550) {
            setMobile(!mobile)
        }
    }, []);


    const handleDataEvent = (tab) => {
        dataLayer.push({
            'insurance_name': `${props.insuranceName}`,
            'event': `${tab} selected`
        });
    }

    // determine what tabs to show and which one should be checked as default

    const tabs = () => {

        if (tabData.insuranceCoverageInfo !== null && tabData.damageClaimInfo !== null && tabData.terminateInsuranceInfo !== null) {
            return <React.Fragment>
                <input type="radio" id="tab-1" name="tab-effect-1" defaultChecked="checked" onChange={() => handleDataEvent('Om försäkringen')} />
                <label htmlFor="tab-1">
                    <span
                        className="possessions-icon"
                        dangerouslySetInnerHTML={{ __html: IconHelper('info-circle-line').outerHTML }}>
                    </span>
                    Om försäkringen
                </label>

                <input type="radio" id="tab-2" name="tab-effect-1" onChange={() => handleDataEvent('Anmäl skada')} />
                <label htmlFor="tab-2">
                    <span
                        className="possessions-icon"
                        dangerouslySetInnerHTML={{ __html: IconHelper('medical').outerHTML }}>
                    </span>
                    Anmäl skada
                </label>

                <input type="radio" id="tab-3" name="tab-effect-1" onChange={() => handleDataEvent('Avsluta försäkring')} />
                <label htmlFor="tab-3">
                    <span
                        className="possessions-icon"
                        dangerouslySetInnerHTML={{ __html: IconHelper('minus').outerHTML }}>
                    </span>
                    Avsluta försäkring
                </label>
            </React.Fragment>;

        } else if (tabData.insuranceCoverageInfo === null && tabData.damageClaimInfo !== null && tabData.terminateInsuranceInfo !== null) {
            return <React.Fragment>
                <input type="radio" id="tab-2" name="tab-effect-1" defaultChecked="checked" onChange={() => handleDataEvent('Anmäl skada')} />
                <label htmlFor="tab-2">
                    <span
                        className="possessions-icon"
                        dangerouslySetInnerHTML={{ __html: IconHelper('medical').outerHTML }}>
                    </span>
                    Anmäl skada
                </label>

                <input type="radio" id="tab-3" name="tab-effect-1" onChange={() => handleDataEvent('Avsluta skada')} />
                <label htmlFor="tab-3">
                    <span
                        className="possessions-icon"
                        dangerouslySetInnerHTML={{ __html: IconHelper('minus').outerHTML }}>
                    </span>
                    Avsluta försäkring
                </label>
            </React.Fragment>;
        } else if (tabData.insuranceCoverageInfo === null && tabData.damageClaimInfo === null && tabData.insuranceCoverageInfo !== null) {
            return <React.Fragment>
                <input type="radio" id="tab-3" name="tab-effect-1" defaultChecked="checked" onChange={() => handleDataEvent('Avsluta skada')} />
                <label htmlFor="tab-3">
                    <span
                        className="possessions-icon"
                        dangerouslySetInnerHTML={{ __html: IconHelper('minus').outerHTML }}>
                    </span>
                    Avsluta försäkring
                </label>
            </React.Fragment>;
        } else if (tabData.insuranceCoverageInfo === null && tabData.damageClaimInfo !== null && tabData.terminateInsuranceInfo === null) {
                return <React.Fragment>
                    <input type="radio" id="tab-2" name="tab-effect-1" defaultChecked="checked" onChange={() => handleDataEvent('Anmäl skada')} />
                    <label htmlFor="tab-2">
                        <span
                            className="possessions-icon"
                            dangerouslySetInnerHTML={{ __html: IconHelper('medical').outerHTML }}>
                        </span>
                        Anmäl skada
                    </label>
                </React.Fragment>;

            } else if (tabData.insuranceCoverageInfo !== null && tabData.damageClaimInfo !== null && tabData.terminateInsuranceInfo === null) {
                return <React.Fragment>
                    <input type="radio" id="tab-1" name="tab-effect-1" defaultChecked="checked" onChange={() => handleDataEvent('Om försäkringen')} />
                    <label htmlFor="tab-1">
                        <span
                            className="possessions-icon"
                            dangerouslySetInnerHTML={{ __html: IconHelper('info-circle-line').outerHTML }}>
                        </span>
                        Om försäkringen
                    </label>

                    <input type="radio" id="tab-2" name="tab-effect-1" onChange={() => handleDataEvent('Anmäl skada')} />
                    <label htmlFor="tab-2">
                        <span
                            className="possessions-icon"
                            dangerouslySetInnerHTML={{ __html: IconHelper('medical').outerHTML }}>
                        </span>
                        Anmäl skada
                    </label>
            </React.Fragment>;

            } else if (tabData.insuranceCoverageInfo !== null && tabData.damageClaimInfo === null && tabData.terminateInsuranceInfo !== null) {
                return <React.Fragment>
                    <input type="radio" id="tab-1" name="tab-effect-1" defaultChecked="checked" onChange={() => handleDataEvent('Om försäkringen')} />
                    <label htmlFor="tab-1">
                        <span
                            className="possessions-icon"
                            dangerouslySetInnerHTML={{ __html: IconHelper('info-circle-line').outerHTML }}>
                        </span>
                        Om försäkringen
                    </label>

                    <input type="radio" id="tab-3" name="tab-effect-1" onChange={() => handleDataEvent('Avsluta försäkringen')} />
                    <label htmlFor="tab-3">
                        <span
                            className="possessions-icon"
                            dangerouslySetInnerHTML={{ __html: IconHelper('minus').outerHTML }}>
                        </span>
                        Avsluta försäkring
                    </label>
            </React.Fragment>;
        } else if (tabData.insuranceCoverageInfo !== null && tabData.damageClaimInfo === null && tabData.terminateInsuranceInfo === null) {
            return <React.Fragment>
                <input type="radio" id="tab-1" name="tab-effect-1" defaultChecked="checked" onChange={() => handleDataEvent('Om försäkringen')} />
                <label htmlFor="tab-1">
                    <span
                        className="possessions-icon"
                        dangerouslySetInnerHTML={{ __html: IconHelper('info-circle-line').outerHTML }}>
                    </span>
                    Om försäkringen
                </label>
            </React.Fragment>;
        } else {
                return;
            }
        }

    const tabData = props.tabData;
    const insuranceName = props.insuranceName;

    return (
            <div className="tabs-container">
            <div className="tabs-container__tabs effect-1">

                { tabs(tabData)}

                <div className="tabs-container__tab-content">

                   {tabData.insuranceCoverageInfo !== null &&
                    <section id="tab-item-1">
                         <PossessionsTableBase
                            mobile={mobile}
                            insuranceName={insuranceName}
                            content={tabData.insuranceCoverageInfo}
                            key={uuidv4()} />
                    </section>
                    }

                    {tabData.damageClaimInfo !== null &&
                        <section id="tab-item-2">
                            <div className="tab-item-2__content">
                                <h3>{tabData.damageClaimInfo.heading}</h3>
                                <RawHtml className="text">{tabData.damageClaimInfo.description}</RawHtml>
                                
                                <a className="phone" callto={tabData.damageClaimInfo.phone}>
                                    <span
                                        className="phone-icon"
                                        dangerouslySetInnerHTML={{ __html: IconHelper('phone').outerHTML }}>
                                    </span>
                                    {tabData.damageClaimInfo.phone}
                                </a>
                                <a className="link arrow-link" href={tabData.damageClaimInfo.link.url}>{tabData.damageClaimInfo.link.text}
                                    <span
                                        dangerouslySetInnerHTML={{ __html: IconHelper('long-arrow-right').outerHTML }}>
                                    </span>
                                </a>
                            </div>
                        </section>
                    }

                    {tabData.terminateInsuranceInfo !== null &&
                        <section id="tab-item-3">
                            <div className="tab-item-3__content">
                                <h3>{tabData.terminateInsuranceInfo.heading}</h3>
                                <RawHtml className="text">{tabData.terminateInsuranceInfo.description}</RawHtml>
                                <a className="phone" callto={tabData.terminateInsuranceInfo.phone}>{tabData.terminateInsuranceInfo.phone}</a>
                                <a className="link arrow-link" href={tabData.terminateInsuranceInfo.link.url}>{tabData.terminateInsuranceInfo.link.text}
                                    <span
                                        dangerouslySetInnerHTML={{ __html: IconHelper('long-arrow-right').outerHTML }}>
                                    </span>
                                </a>
                            </div>
                        </section>
                    }

                 </div>
            </div>
        </div>
    );    
}

export default PossessionsTabs;
